import { http } from "msw";
import type { ImageRef, Post } from "../../api/types";
import * as viewerState from "../viewer-state";
import { allPosts, decoratePost, findViewerCreator, notFound, runMutation, toCreatorSummary } from "./shared";

interface CreatePostBody {
  body: string;
  mediaKey?: string;
}

let createdPostSequence = 0;

async function findPost(id: string): Promise<Post | undefined> {
  return (await allPosts()).find((p) => p.id === id);
}

export const postsHandlers = [
  http.post("/api/posts", async ({ request }) => {
    const { body, mediaKey } = (await request.json()) as CreatePostBody;
    const me = await findViewerCreator();
    const media: ImageRef | undefined = mediaKey ? { key: mediaKey, alt: "shared media" } : undefined;
    const post: Post = {
      id: `viewer-post-${createdPostSequence}`,
      author: toCreatorSummary(me),
      kind: media ? "media" : "text",
      body,
      media,
      createdAt: new Date().toISOString(),
      likes: 0,
      comments: 0,
      reposts: 0,
      liked: false,
      bookmarked: false,
      tags: [],
    };
    return runMutation(() => {
      createdPostSequence += 1;
      post.id = `viewer-post-${createdPostSequence}`;
      viewerState.addCreatedPost(post);
      return decoratePost(post);
    });
  }),

  http.post("/api/posts/:id/like", async ({ params }) => {
    const post = await findPost(String(params.id));
    if (!post) return notFound("Post not found");
    return runMutation(() => {
      viewerState.setPostLiked(post.id, true);
      const decorated = decoratePost(post);
      return { liked: decorated.liked, likes: decorated.likes };
    });
  }),
  http.delete("/api/posts/:id/like", async ({ params }) => {
    const post = await findPost(String(params.id));
    if (!post) return notFound("Post not found");
    return runMutation(() => {
      viewerState.setPostLiked(post.id, false);
      const decorated = decoratePost(post);
      return { liked: decorated.liked, likes: decorated.likes };
    });
  }),

  http.post("/api/posts/:id/bookmark", async ({ params }) => {
    const post = await findPost(String(params.id));
    if (!post) return notFound("Post not found");
    return runMutation(() => {
      viewerState.setPostBookmarked(post.id, true);
      const decorated = decoratePost(post);
      return { bookmarked: decorated.bookmarked, likes: decorated.likes };
    });
  }),
  http.delete("/api/posts/:id/bookmark", async ({ params }) => {
    const post = await findPost(String(params.id));
    if (!post) return notFound("Post not found");
    return runMutation(() => {
      viewerState.setPostBookmarked(post.id, false);
      const decorated = decoratePost(post);
      return { bookmarked: decorated.bookmarked, likes: decorated.likes };
    });
  }),
];
